document.addEventListener('turbolinks:load', function () {
  $(
    '#autorequisition-by-code-selected, #autorequisition-by-cost-selected, #autorequisition-by-stock-selected, #autorequisition-by-family, #autorequisition-by-product-type'
  ).hide();
  $('[name="by_code"]').on('click', function () {
    $('#autorequisition-by-code-selected').toggle(this.checked);
  });
  $('[name="by_cost"]').on('click', function () {
    $('#autorequisition-by-cost-selected').toggle(this.checked);
  });
  $('[name="by_stock"]').on('click', function () {
    $('#autorequisition-by-stock-selected').toggle(this.checked);
  });
  $('[name="by_family"]').on('click', function () {
    $('#autorequisition-by-family').toggle(this.checked);
  });
  $('[name="by_product_type"]').on('click', function () {
    $('#autorequisition-by-product-type').toggle(this.checked);
  });
});
